import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { BrandingProvider } from "@/context/BrandingContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { EnvDeviceRoute } from "@/components/EnvDeviceRoute";
import { ConfirmHost } from "@/components/Confirm";
import PageMe from "@/pages/PageMe";
import { CommandLayout } from "@/components/CommandLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Incidents from "@/pages/Incidents";
import IncidentDetail from "@/pages/IncidentDetail";
import Vehicles from "@/pages/Vehicles";
import MapView from "@/pages/MapView";
import Archive from "@/pages/Archive";
import AuditLog from "@/pages/AuditLog";
import Beheer from "@/pages/Beheer";
import InstallOverview from "@/pages/InstallOverview";
import VehicleApp from "@/pages/VehicleApp";
import Enroll from "@/pages/Enroll";
import Reports from "@/pages/Reports";
import IncidentReport from "@/pages/IncidentReport";
import LivePhone from "@/pages/LivePhone";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import PopoutMap from "@/pages/PopoutMap";
import PopoutLive from "@/pages/PopoutLive";
import PagerApp from "@/pages/PagerApp";
import KazerneMonitor from "@/pages/KazerneMonitor";
import KnowledgeBase from "@/pages/KnowledgeBase";
import Tasks from "@/pages/Tasks";
import Vault from "@/pages/Vault";
import LandingPage from "@/pages/LandingPage";

function Command({ children, roles }) {
  return (
    <ProtectedRoute roles={roles || ["beheerder", "meldkamer"]}>
      <CommandLayout>{children}</CommandLayout>
    </ProtectedRoute>
  );
}

function RootRedirect() {
  const { user, ready } = useAuth();
  if (!ready) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "voertuig" ? "/voertuig" : "/dashboard"} replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrandingProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<Command><Dashboard /></Command>} />
            <Route path="/incidenten" element={<Command><Incidents /></Command>} />
            <Route path="/incidenten/:id" element={<Command><IncidentDetail /></Command>} />
            <Route path="/incidenten/:id/rapport" element={<Command><IncidentReport /></Command>} />
            <Route path="/voertuigen" element={<Command><Vehicles /></Command>} />
            <Route path="/kaart" element={<Command><MapView /></Command>} />
            <Route path="/taken" element={<Command><Tasks /></Command>} />
            <Route path="/kluis" element={<Command roles={["beheerder", "meldkamer"]}><Vault /></Command>} />
            <Route path="/rapportage" element={<Command><Reports /></Command>} />
            <Route path="/kennisbank" element={<Command><KnowledgeBase /></Command>} />
            <Route path="/archief" element={<Command><Archive /></Command>} />
            <Route path="/audit" element={<Command roles={["beheerder"]}><AuditLog /></Command>} />
            <Route path="/beheer" element={<Command roles={["beheerder", "meldkamer"]}><Beheer /></Command>} />
            <Route path="/beheer/installatie" element={<InstallOverview />} />
            <Route path="/pageme" element={<Command roles={["beheerder", "meldkamer"]}><PageMe /></Command>} />
            <Route path="/voertuig" element={<VehicleApp />} />
            <Route path="/pager" element={<PagerApp />} />
            <Route path="/kazerne" element={<KazerneMonitor />} />
            <Route path="/o/:code/pager" element={<EnvDeviceRoute envKey="pagerEnvId"><PagerApp /></EnvDeviceRoute>} />
            <Route path="/o/:code/voertuig" element={<EnvDeviceRoute envKey="deviceEnvId"><VehicleApp /></EnvDeviceRoute>} />
            <Route path="/o/:code/kazerne" element={<EnvDeviceRoute envKey="monitorEnvId"><KazerneMonitor /></EnvDeviceRoute>} />
            <Route path="/activeren" element={<Enroll />} />
            <Route path="/live/:token" element={<LivePhone />} />
            <Route path="/popout/kaart/:id" element={<PopoutMap />} />
            <Route path="/popout/live/:id" element={<PopoutLive />} />
            <Route path="/wachtwoord-vergeten" element={<ForgotPassword />} />
            <Route path="/wachtwoord-herstellen" element={<ResetPassword />} />
            <Route path="*" element={<RootRedirect />} />
          </Routes>
          <ConfirmHost />
        </BrowserRouter>
        </BrandingProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
